/**
 * @generated SignedSource<<a3b0214808b205a5868e0676a2c9e6f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveGroupMemberInput = {
  clientMutationId?: string | null | undefined;
  groupId: string;
  memberId: string;
};
export type RemoveGroupMemberMutation$variables = {
  input: RemoveGroupMemberInput;
};
export type RemoveGroupMemberMutation$data = {
  readonly removeGroupMember: {
    readonly clientMutationId: string | null | undefined;
    readonly removedGroupMemberId: string;
  } | null | undefined;
};
export type RemoveGroupMemberMutation = {
  response: RemoveGroupMemberMutation$data;
  variables: RemoveGroupMemberMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveGroupMemberPayload",
    "kind": "LinkedField",
    "name": "removeGroupMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removedGroupMemberId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveGroupMemberMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveGroupMemberMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "46c08040e60fe0a8c4d57ae5aacb7b48",
    "id": null,
    "metadata": {},
    "name": "RemoveGroupMemberMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveGroupMemberMutation(\n  $input: RemoveGroupMemberInput!\n) {\n  removeGroupMember(input: $input) {\n    clientMutationId\n    removedGroupMemberId\n  }\n}\n"
  }
};
})();

(node as any).hash = "93d6180815b39ddf5b6eb3bcc91d81f4";

export default node;
